"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaleTimeline = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var usePoolParts_1 = require("../../pool/hooks/usePoolParts");
var utils_1 = require("../../pool/utils");
var getRegisterEnd = function (date, reachedMinAllocation) {
    if (!date || reachedMinAllocation)
        return undefined;
    return date.utc();
};
function useSaleTimeline() {
    var sale = (0, usePoolParts_1.usePoolSale)()[0];
    var _a = (0, utils_1.getSaleRegisterStartEnd)(sale), registerStart = _a.registerStart, registerEnd = _a.registerEnd;
    var duration = sale.durationHours, registerDuration = sale.registerDuration;
    if (!sale.startDate) {
        return {
            start: undefined,
            end: undefined,
            duration: duration,
            registerStart: registerStart,
            registerEnd: registerEnd,
            registerDuration: registerDuration,
            fcfsStart: undefined,
        };
    }
    var start = (0, dayjs_1.default)(sale.startDate).utc();
    var end = sale.durationHours
        ? start.add(sale.durationHours, 'hour').utc()
        : undefined;
    var fcfsStart = sale.fcfsDuration && end
        ? end.subtract(sale.fcfsDuration, 'hour')
        : undefined;
    return {
        start: start,
        end: end,
        duration: duration,
        registerStart: registerStart && registerStart.utc(),
        registerEnd: getRegisterEnd(registerEnd, sale.reachedMinBaseAllocation),
        registerDuration: registerDuration,
        fcfsStart: fcfsStart,
    };
}
exports.useSaleTimeline = useSaleTimeline;
